var _rect, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _rect7, _circle, _line2, _rect8, _rect9, _rect0, _rect1, _rect10, _line3, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusWidgetPlaceholderTablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 732,
  viewBox: "0 0 704 732",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 703,
  height: 731,
  rx: 7.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 703,
  height: 731,
  rx: 7.5,
  stroke: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63,
  width: 304,
  height: 78,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 153,
  width: 304,
  height: 30,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 203.5,
  x2: 20,
  y2: 203.5,
  stroke: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 137.5,
  y: 223,
  width: 60,
  height: 39,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 274,
  width: 295,
  height: 107,
  fill: "#E5E5E5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 167.5,
  cy: 425,
  r: 32,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 352.5,
  y1: 63,
  x2: 352.5,
  y2: 712,
  stroke: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 63,
  width: 160,
  height: 17,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 100,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 128,
  width: 304,
  height: 34,
  fill: "#E5E5E5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 174,
  width: 304,
  height: 170,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 356,
  width: 160,
  height: 30,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 380,
  y1: 405.5,
  x2: 684,
  y2: 405.5,
  stroke: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 426,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 454,
  width: 304,
  height: 34,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 500,
  width: 304,
  height: 170,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 380,
  y: 682,
  width: 160,
  height: 30,
  fill: "#E5E5E5"
})));
export default SvgPlusWidgetPlaceholderTablet;